import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

import { useMetaStore } from '../meta/metaStore';
import { useRecipeStore } from '../recipe/recipeStore';
import { useCriteriaStore } from '../criteria/criteriaStore';

import { getRecipeForShareWidget } from './shareWidgetStoreLogic';

export const useShareWidgetStore = defineStore('ShareWidgetStore', () => {
  const recipeStore = useRecipeStore();
  const metaStore = useMetaStore();
  const criteriaStore = useCriteriaStore();

  // State
  const showModal = ref<boolean>(false);

  // Actions
  function openModal(): void {
    showModal.value = true;
  }

  function closeModal(): void {
    showModal.value = false;
  }

  // Getters
  const isRecipeValid = recipeStore.isRecipeCorrect;

  const recipe = computed(() =>
    getRecipeForShareWidget(
      criteriaStore.itineraryCriteria,
      metaStore.metaAffiliateId
    )
  );

  return {
    // State
    showModal,

    // Actions
    openModal,
    closeModal,

    // Getters
    isRecipeValid,
    recipe,
  };
});
